/**
 * index.js
 *
 * @Author: zhangce
 * @Date: 17/8/23 上午11:38
 */

import MapTag from './MapTag';
import CheckableMapTag from './CheckableMapTag';
import MapTagGroup from './MapTagGroup';

MapTag.CheckableMapTag = CheckableMapTag;
export { CheckableMapTag, MapTagGroup };
export default MapTag;



// WEBPACK FOOTER //
// ./src/maptag/index.js